/**
 * @module olgm/asserts
 */
/* Based on https://github.com/openlayers/openlayers/blob/master/src/ol/asserts.js */
/**
 * @param {*} assertion Assertion we expected to be truthy
 * @param {string=} opt_message Error message in case of failure
 */
export function assert(assertion, opt_message) {
  if (!assertion) {
    var message = 'Assertion failed';
    if (opt_message) {
      message += ': ' + opt_message;
    }
    throw new Error(message);
  }
}

//# sourceMappingURL=asserts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@geosolutions/olgm/asserts.js
// module id = 152
// module chunks = 1